// frontend/src/App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./portal/Login";
import "./index.css";
import { AuthProvider } from "./context/AuthContext";
import AuthCallback from "./portal/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./Layout";
import LigComponent from "./components/Lig/LigComponent";
import MyLigComponent from "./components/Lig/MyLigComponent";
import LigReviewComponent from "./components/Lig/LigReviewComponent";
import LigFeedComponent from "./components/Lig/LigFeedComponent";
import LigOutreachComponent from "./components/Lig/LigOutreachComponent";
import LigLandingComponent from "./components/Lig/LigLandingComponent";
import JobsAdmin from "./components/Admin/JobsAdmin";


export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route element={<Layout />}>
            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />

            {/*Auth Portal Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/portal/auth-callback" element={<AuthCallback />} />

            {/*Admin Pages Routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <LigComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mylig/:uname"
              element={
                <ProtectedRoute>
                  <MyLigComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/years"
              element={
                <ProtectedRoute>
                  <LigReviewComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/feed/:year"
              element={
                <ProtectedRoute>
                  <LigFeedComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/invite"
              element={
                <ProtectedRoute>
                  <LigOutreachComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lig/landing"
              element={
                <ProtectedRoute>
                  <LigLandingComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ligadmin"
              element={
                <ProtectedRoute>
                  <JobsAdmin />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
